import controller from '../product-filter.controller'
import template from './dynamic-filter.html'

export default {
  bindings: {
    filters: '<'
  },
  template,
  controller
}
